import camelcaseKeys from 'camelcase-keys';
import { gql } from 'graphql-request';

import {
  AxiosAccessTokenClientEhrm,
  PropertyGraphClient,
} from '@hcs/http-clients';
import { MlsListItem,MlsLookupResponse } from '@hcs/types';
import { EHRMANTRAUT_URL } from '@hcs/urls';
import { logException } from '@hcs/utils';

const FETCH_MLS_QUERY = gql`
  query FetchMls($mlsId: string!) {
    mlsLookup(id: { id: $mlsId }) {
      abbreviation
      fips {
        id
        name
      }
      lastRefreshed
      mlsID
      name
      regulations {
        active
        augmenting
        cancelled
        closed
        closedLoginPrice
        comingSoon
        comingling
        contingent
        contingentWithKickOut
        cooperatingBrokerage
        copyrightStatement
        deleted
        disclaimer
        expired
        leased
        logo
        logoOverlay
        pending
        photosClosedAll
        photosClosedFirstOnly
        photosClosedHistory
        photosClosedLogin
        photosLogoOverlay
        sold
        unknown
        withdrawn
      }
    }
  }
`;

export const MlsLookupApi = {
  fetchMls: async (mlsId: number | null) => {
    if (mlsId === null) {
      logException('fetchMls: mlsId argument was null');
      return;
    }

    const response: MlsLookupResponse = await PropertyGraphClient.request(
      FETCH_MLS_QUERY,
      {
        mlsId,
      }
    );
    return response?.mlsLookup;
  },
  fetchAllMls: async () => {
    const response = await AxiosAccessTokenClientEhrm.get<MlsListItem[]>(
      `${EHRMANTRAUT_URL}/mls`
    );
    return camelcaseKeys(response.data, { deep: true });
  },
};
